// extracted by mini-css-extract-plugin
module.exports = {"h1":"listConflicts_h1__12ZOO","submitConflictBtn":"listConflicts_submitConflictBtn__35VIp","addConflictBtn":"listConflicts_addConflictBtn__jev8A"};